import {
	setOperatorForRelativeDates
} from './relative-dates';
import {
	removeTable_v2
} from './initialize-sdt';

window.globalBlueColor = "#437beb";
window.globalBlackColor = 'black';
window.globalFiltersArray_v2 = [];

export const intializeFilter = function () {
	// remainingColumns=[];
	if (!window.globalTableHeads_v2) return;

	var style = document.createElement('style');
	style.type = 'text/css';
	style.innerHTML = '.sdt-f-input{border: none;width:100%;height:20px;padding:0px}';
	style.innerHTML += '.sdt-f-input:focus{outline:none}'
	style.innerHTML += '.sdt-f-select{width:100%;border:none;padding-top:10px;padding-bottom:10px;}';

	document.getElementsByTagName('head')[0].appendChild(style);

	var filterDiv = document.getElementById('custom-filter#' + window.GlobalId_v2);
	filterDiv.style['text-align'] = 'left';
	filterDiv.style.width = '500px';
	filterDiv.style.display = "none";

	setupHeader(filterDiv);
	setupTable(filterDiv);

	//add notification to the bottom
	var divNotification = document.createElement('div');
	divNotification.style["text-align"] = "right";
	divNotification.style.color = "red";
	divNotification.id = "f-n#" + window.GlobalId_v2;
	divNotification.style.display = "none";
	filterDiv.appendChild(divNotification);

	//add button to the bottom
	var divFooter = document.createElement('div');
	var inputButton = document.createElement("input");
	inputButton.type = "button";
	inputButton.value = "Apply";
	inputButton.id = "advanceFilterButton" + window.GlobalId_v2;
	inputButton.style.width = "100%";
	inputButton.style['background-color'] = window.globalTileColor;
	inputButton.style.color = "white";
	inputButton.style.border = "none";
	inputButton.style.padding = "10px";
	inputButton.style.cursor = "pointer";
	divFooter.appendChild(inputButton);
	filterDiv.appendChild(divFooter);

	inputButton.onclick = function () {

		var event = new CustomEvent("filterEvent");
		updateFilterTableHeads();
		window.msg_v2 = 3;
		window.dispatchEvent(event);
		toggleFilter_v2(window.GlobalId_v2);
	};

	filterFlag = true;
	let control = document.getElementById('control');
	control.style.display = "flex";
	// showing a filter row by default
	let allRows = document.getElementsByTagName('tr') ? document.getElementsByTagName('tr') : [];
	let countRows = 0;
	for (let element of allRows) {
		if (element.id.includes("f-t#" + window.GlobalId_v2) && !element.id.includes("0")) {
			countRows++;
		}
	}
	if (countRows == 0) {
		addRow();
	}

}

export const loadViewFilters = function (filteredView) {
	let table = document.getElementById("f-t#" + window.GlobalId_v2);

	let filterViewFlag = false;
	let columns = filteredView.defaultTable.columns;
	for (let index = 0; index < columns.length; index++) {
		if (columns[index].filters.length || columns[index].secondValue) {
			columns[index].filterFlag = true;
			filterViewFlag = true;
		}
	}

	if (filterViewFlag == true) {
		table.id = '';
		table.style.display = 'none';

		var filterDiv = document.getElementById('custom-filter#' + window.GlobalId_v2);
		filterDiv.style['text-align'] = 'left';
		filterDiv.style.width = '500px';
		filterDiv.style.display = "none";
		setupTable(filterDiv);

		// adding Value 2 label if between filter is found
		let filterRows = document.getElementsByClassName('sdt-f-select');
		let count = 0;
		for (let i = 0; i < filterRows.length; i++) {
			let options = filterRows[i].options;
			let selectedIndex = filterRows[i].options.selectedIndex;
			for (let index = 0; index < options.length; index++) {
				if (index == selectedIndex) {
					if (options[index].label == "Between") {
						checkFlag = true;
						count++;
					}
				}
			}
		}
		if (count > 0) {
			let rows = document.getElementsByTagName('th');
			for (let i = 0; i < rows.length; i++) {
				if (rows[i].id == 'firstValue') {
					rows[i].innerText = 'Value 1';
				}
				if (rows[i].id == 'secondValue') {
					rows[i].innerText = 'Value 2';
				}
			}
		}

		let prevFilterButton = document.getElementById("advanceFilterButton" + window.GlobalId_v2);
		prevFilterButton.id = '';
		prevFilterButton.style.display = 'none';

		//add button to the bottom
		var divFooter = document.createElement('div');
		var inputButton = document.createElement("input");
		inputButton.type = "button";
		inputButton.value = "Apply";
		inputButton.id = "advanceFilterButton" + window.GlobalId_v2;
		inputButton.style.width = "100%";
		inputButton.style['background-color'] = window.globalTileColor;
		inputButton.style.color = "white";
		inputButton.style.border = "none";
		inputButton.style.padding = "10px";
		inputButton.style.cursor = "pointer";
		divFooter.appendChild(inputButton);
		filterDiv.appendChild(divFooter);

		// click event for filtering when more filters added in existing filter
		inputButton.onclick = function () {
			var event = new CustomEvent("filterEvent");
			updateFilterTableHeads();
			window.msg_v2 = 3;
			window.dispatchEvent(event);
			toggleFilter_v2(window.GlobalId_v2);

		};

		// loading filtered data
		var event = new CustomEvent("filterEvent");
		updateFilterTableHeads();
		window.msg_v2 = 3;
		window.dispatchEvent(event);

	}
}

function updateFilterTableHeads() {
	let filterTable = document.getElementById("f-t#" + window.GlobalId_v2);
	let filterValue;
	for (let i = 1; i < filterTable.rows.length; i++) {

		var labelName = filterTable.rows[i].cells[0].innerHTML;

		if (labelName.includes("<")) { //td contains select

			var selectTag = filterTable.rows[i].querySelector("td > select");
			labelName = selectTag.options[selectTag.selectedIndex].text;
		}

		for (var j = 0; j < window.globalTableHeads_v2.length; j++) {

			if (window.globalTableHeads_v2[j].labelName == labelName) {

				let comparisonType = filterTable.rows[i].cells[1].querySelector("select").value;
				let inputContainer = filterTable.rows[i].cells[2].querySelector("select");
				if (inputContainer == null) {
					inputContainer = filterTable.rows[i].cells[2].querySelector("input");
				}

				filterValue = inputContainer.value;

				emptyNotification();
				let secondValue = null;
				if (comparisonType == "Between") {
					comparisonType = "btw";
					secondValue = filterTable.rows[i].cells[3].querySelector("input").value;
				}

				// changing back to symbols from words for BE
				if (comparisonType == 'Equal to') {
					comparisonType = '=';
				} else if (comparisonType == 'Not equal to') {
					comparisonType = '!=';
				} else if (comparisonType == 'Greater than') {
					comparisonType = '>';
				} else if (comparisonType == 'Less than') {
					comparisonType = '<';
				} else if (comparisonType == 'Greater than equal to') {
					comparisonType = '>=';
				} else if (comparisonType == 'Less than equal to') {
					comparisonType = '<=';
				} else if (comparisonType == 'Contains') {
					comparisonType = 'Like';
				}

				for (let k = 0; k < window.globalTableHeads_v2.length; k++) {
					if (window.globalTableHeads_v2[k].labelName == labelName) {

						window.globalTableHeads_v2[k].comparisonType = comparisonType;
						window.globalTableHeads_v2[k].filterValue = filterValue;
						window.globalTableHeads_v2[k].secondValue = secondValue;
						window.globalTableHeads_v2[k].filterFlag = true;

						// making object of filters
						// making array of filter objects to handle multiple values filter
						// on same column
						let obj = {
							'fieldName': window.globalTableHeads_v2[k].fieldName,
							'labelName': labelName,
							'comparisonType': comparisonType,
							'filterValue': filterValue,
							'secondValue': secondValue,
							'thirdValue': window.globalTableHeads_v2[k].thirdValue,
							'fourthValue': window.globalTableHeads_v2[k].fourthValue,
							'filterFlag': true,
							'fieldType': window.globalTableHeads_v2[k].fieldType,
							'compTypeDate': window.globalTableHeads_v2[k].compTypeDate,
							'compTypeDate2': window.globalTableHeads_v2[k].compTypeDate2,
							'dataType': window.globalTableHeads_v2[k].dataType
						};
						window.globalFiltersArray_v2.push(obj);
						break;
					}
				}

				// removing duplicate filters from globalFiltersArray
				window.globalFiltersArray_v2 = removeDuplicateFilters(window.globalFiltersArray_v2, 'comparisonType', 'filterValue');

				// relative dates
				if (window.globalTableHeads_v2[j].compTypeDate && window.globalTableHeads_v2[j].thirdValue) { //retreiving relative filter
					setOperatorForRelativeDates(window.globalTableHeads_v2);
				} else if (checkRelativeDateFilter(window.globalTableHeads_v2[j].comparisonType)) { // applying relative filter
					setOperatorForRelativeDates(window.globalTableHeads_v2);
				}

				// for date format validation
				for (let i = 0; i < window.globalTableHeads_v2.length; i++) {
					if (window.globalTableHeads_v2[i].fieldType == 'date' && ignoreDateValidation(window.globalTableHeads_v2[i].comparisonType)) {
						if (window.globalTableHeads_v2[i].filterValue) {
							let res = validatedate(window.globalTableHeads_v2[i].filterValue);
							if (window.globalTableHeads_v2[i].secondValue != null && res == true) {
								emptyNotification();
								validatedate(window.globalTableHeads_v2[i].secondValue);
							}
						}
					}
				}
			}
		}
	}
}

function removeDuplicateFilters(duplicateArray, key1, key2) {
	var arrResult = {};
	for (let i = 0, n = duplicateArray.length; i < n; i++) {
		var item = duplicateArray[i];
		arrResult[item[key1] + " - " + item[key2]] = item;
	}

	var i = 0;
	var nonDuplicatedArray = [];
	for (var item in arrResult) {
		nonDuplicatedArray[i++] = arrResult[item];
	}
	// duplicateArray = nonDuplicatedArray;
	return nonDuplicatedArray;
}

window.relativeDates = [
	"Day(s) ago", "Week(s) ago", "Month(s) ago", "Year(s) ago", "Quarter(s) ago",
	"Day(s) from now", "Week(s) from now", "Month(s) from now", "Year(s) from now", "Quarter(s) from now"
];

function checkRelativeDateFilter(operator) {
	for (let i = 0; i < window.relativeDates.length; i++) {
		if (operator == window.relativeDates[i]) {
			return true;
		}
	}
	return false;
}

// contains all options that don't need to be checked for proper date format.
window.options = [
	"Like", "Day(s) ago", "Week(s) ago", "Month(s) ago", "Year(s) ago", "Quarter(s) ago",
	"Day(s) from now", "Week(s) from now", "Month(s) from now", "Year(s) from now", "Quarter(s) from now"
];

function ignoreDateValidation(operator) {
	for (let i = 0; i < window.options.length; i++) {
		if (operator == window.options[i]) {
			return false;
		}
	}
	return true;
}

var filterRowId = 0;
var remainingColumns = [];

function setupTable(filterDiv) {
	filterRowId = 0;
	var emptyFilterFlag = true;
	var tableTag = document.createElement('table');
	tableTag.id = "f-t#" + window.GlobalId_v2;
	tableTag.style["table-layout"] = "fixed";
	tableTag.style.width = "100%";
	tableTag.style.padding = '10px';
	tableTag.style['border-spacing'] = "20px";
	tableTag.style['border'] = window.borderBottomCSS;

	var trTag = document.createElement('tr');
	trTag.id = tableTag.id + filterRowId.toString();
	filterRowId++;
	var tdTag = document.createElement('th');
	tdTag.style.width = "105px";
	var label = document.createTextNode("Column Name");
	tdTag.appendChild(label);
	trTag.appendChild(tdTag);

	tdTag = document.createElement('th');
	tdTag.style.width = "105px";
	label = document.createTextNode("Operation");
	tdTag.appendChild(label);
	trTag.appendChild(tdTag);

	tdTag = document.createElement('th');
	tdTag.style.width = "105px";
	tdTag.id = "firstValue";
	label = document.createTextNode("Value");
	tdTag.appendChild(label);
	trTag.appendChild(tdTag);

	tdTag = document.createElement('th');
	tdTag.id = "secondValue";
	tdTag.style.width = "100px";
	trTag.appendChild(tdTag);
	tdTag = document.createElement('th');
	trTag.appendChild(tdTag);

	tableTag.appendChild(trTag);

	window.globalTableHeads_v2.forEach((head) => {

		if (head.filterFlag) {
			if (head.filters.length > 1) {
				for (let s = 0; s < head.filters.length; s++) {
					emptyFilterFlag = false;
					trTag = document.createElement('tr');
					trTag.id = tableTag.id + filterRowId.toString();
					filterRowId++;

					//Add label
					tdTag = document.createElement('td');
					tdTag.style['border-bottom'] = window.borderBottomCSS;
					tdTag.style['padding-top'] = "10px";
					tdTag.style['padding-bottom'] = "10px";
					label = document.createTextNode(head.labelName);
					tdTag.appendChild(label);
					trTag.appendChild(tdTag);

					//Add select
					tdTag = document.createElement('td');
					tdTag.style['border-bottom'] = window.borderBottomCSS;
					var inputSelect = document.createElement('select');
					inputSelect.id = "s2-" + window.GlobalId_v2;
					inputSelect.className = "sdt-f-select";

					if (head.compTypeDate && head.thirdValue) {
						generateComparisonDropDown(inputSelect, head.fieldType, head.compTypeDate);
					} else {
						generateComparisonDropDown(inputSelect, head.fieldType, head.filters[s].operator);
					}

					tdTag.appendChild(inputSelect);
					trTag.appendChild(tdTag);

					//Add filter value input
					tdTag = document.createElement('td');
					tdTag.style['border-bottom'] = window.borderBottomCSS;
					if (head.dataType == "array") {
						var valSelect = document.createElement('select');
						valSelect.className = "sdt-f-select";
						for (var i = 0; i < head.filterOptions.length; i++) {
							var valOption = document.createElement('option')
							var optionValue = document.createTextNode(head.filterOptions[i]);
							valOption.appendChild(optionValue);
							if (head.filterOptions[i] == head.filters[s]) {
								valOption.selected = true;
							}
							valSelect.appendChild(valOption);
						}
						tdTag.appendChild(valSelect);

					} else if (head.compTypeDate && head.thirdValue) {
						var inputValue = document.createElement('input');
						inputValue.className = "sdt-f-input";
						inputValue.type = "text";
						inputValue.value = head.thirdValue;
					} else {
						var inputValue = document.createElement('input');
						inputValue.className = "sdt-f-input";
						inputValue.type = "text";
						inputValue.value = head.filters[s].value;

						// below if is used to show date in proper format in filter on FE
						if (head.fieldType == "date") {

							if (head.filterValue[s] && head.filterValue[s].includes(' ')) {
								let dt = head.filterValue[s].split(" ");
								dt = dt[0];
								let splitdt = dt.split("-");
								dt = splitdt[2] + '.' + splitdt[1] + '.' + splitdt[0];
								head.filterValue[s] = dt;
								inputValue.value = head.filterValue[s];
							} else {
								inputValue.placeholder = "dd.mm.yyyy";
							}
						}
					}
					tdTag.appendChild(inputValue);
					trTag.appendChild(tdTag);

					tdTag = document.createElement('td');

					if (head.comparisonType == "btw" && head.thirdValue == "") {
						//Add second value input
						// tdTag.style['border-bottom']=window.borderBottomCSS;
						inputValue = document.createElement('input');
						// inputValue.className = "sdt-f-input";
						inputValue.type = "text";
						inputValue.style.border = 'none';
						inputValue.style = "border-bottom: 1px solid #dadada;border-top: none;border-right: none;border-left: none;width: -webkit-fill-available;padding: 10px;outline: none;";
						inputValue.value = head.secondValue;

						// below if is used to show date in proper format in filter on FE
						if (head.fieldType == "date") {
							if (head.secondValue && head.secondValue.includes(' ')) {
								let dt = head.secondValue.split(" ");
								dt = dt[0];
								let splitdt = dt.split("-");
								dt = splitdt[2] + '.' + splitdt[1] + '.' + splitdt[0];
								head.secondValue = dt;
								inputValue.value = head.secondValue;
							} else {
								inputValue.placeholder = "dd.mm.yyyy";
							}
						}
						tdTag.appendChild(inputValue);

					}
					trTag.appendChild(tdTag);

					//For cross
					tdTag = document.createElement('td');
					tdTag.style = "width: 11px;display: -webkit-inline-box;padding-top:10px";
					generateDeleteButton(tdTag);

					//add cross here
					trTag.appendChild(tdTag);
					tableTag.appendChild(trTag);

				}
				// remainingColumns.push(head);
			} else {
				emptyFilterFlag = false;
				trTag = document.createElement('tr');
				trTag.id = tableTag.id + filterRowId.toString();
				filterRowId++;

				//Add label
				tdTag = document.createElement('td');
				tdTag.style['border-bottom'] = window.borderBottomCSS;
				tdTag.style['padding-top'] = "10px";
				tdTag.style['padding-bottom'] = "10px";
				label = document.createTextNode(head.labelName);
				tdTag.appendChild(label);
				trTag.appendChild(tdTag);

				//Add select
				tdTag = document.createElement('td');
				tdTag.style['border-bottom'] = window.borderBottomCSS;
				var inputSelect = document.createElement('select');
				inputSelect.id = "s2-" + window.GlobalId_v2;
				inputSelect.className = "sdt-f-select";

				if (head.compTypeDate && head.thirdValue) {
					generateComparisonDropDown(inputSelect, head.fieldType, head.compTypeDate);
				} else {
					generateComparisonDropDown(inputSelect, head.fieldType, head.comparisonType);
				}

				tdTag.appendChild(inputSelect);
				trTag.appendChild(tdTag);

				//Add filter value input
				tdTag = document.createElement('td');
				tdTag.style['border-bottom'] = window.borderBottomCSS;
				if (head.dataType == "array") {
					var valSelect = document.createElement('select');
					valSelect.className = "sdt-f-select";
					for (var i = 0; i < head.filterOptions.length; i++) {
						var valOption = document.createElement('option')
						var optionValue = document.createTextNode(head.filterOptions[i]);
						valOption.appendChild(optionValue);
						if (head.filterOptions[i] == head.filterValue) {
							valOption.selected = true;
						}
						valSelect.appendChild(valOption);
					}
					tdTag.appendChild(valSelect);

				} else if (head.compTypeDate && head.thirdValue) {
					var inputValue = document.createElement('input');
					inputValue.className = "sdt-f-input";
					inputValue.type = "text";
					inputValue.value = head.thirdValue;
				} else {
					var inputValue = document.createElement('input');
					inputValue.className = "sdt-f-input";
					inputValue.type = "text";
					inputValue.value = head.filterValue;

					// below if is used to show date in proper format in filter on FE
					if (head.fieldType == "date") {

						if (head.filterValue && head.filterValue.includes(' ')) {
							let dt = head.filterValue.split(" ");
							dt = dt[0];
							let splitdt = dt.split("-");
							dt = splitdt[2] + '.' + splitdt[1] + '.' + splitdt[0];
							head.filterValue = dt;
							inputValue.value = head.filterValue;
						} else {
							inputValue.placeholder = "dd.mm.yyyy";
						}
					}
				}
				tdTag.appendChild(inputValue);
				trTag.appendChild(tdTag);

				tdTag = document.createElement('td');

				if (head.comparisonType == "btw" && head.thirdValue == "") {
					//Add second value input
					// tdTag.style['border-bottom']=window.borderBottomCSS;
					inputValue = document.createElement('input');
					// inputValue.className = "sdt-f-input";
					inputValue.type = "text";
					inputValue.style.border = 'none';
					inputValue.style = "border-bottom: 1px solid #dadada;border-top: none;border-right: none;border-left: none;width: -webkit-fill-available;padding: 10px;outline: none;";
					inputValue.value = head.secondValue;

					// below if is used to show date in proper format in filter on FE
					if (head.fieldType == "date") {
						if (head.secondValue && head.secondValue.includes(' ')) {
							let dt = head.secondValue.split(" ");
							dt = dt[0];
							let splitdt = dt.split("-");
							dt = splitdt[2] + '.' + splitdt[1] + '.' + splitdt[0];
							head.secondValue = dt;
							inputValue.value = head.secondValue;
						} else {
							inputValue.placeholder = "dd.mm.yyyy";
						}
					}
					tdTag.appendChild(inputValue);

				}
				trTag.appendChild(tdTag);

				//For cross
				tdTag = document.createElement('td');
				tdTag.style = "width: 11px;display: -webkit-inline-box;padding-top:10px";
				generateDeleteButton(tdTag);

				//add cross here
				trTag.appendChild(tdTag);
				tableTag.appendChild(trTag);

				// so that column is shown again in list
				// remainingColumns.push(head);

			}
			remainingColumns.push(head);
		} else {
			remainingColumns.push(head);
		}
	});

	filterDiv.appendChild(tableTag);
}

function generateDeleteButton(tdTag) {
	var imgTag = document.createElement('img');
	// imgTag.src=require("@/shared/assets/icons/v2/del-btn.png");
	imgTag.addEventListener('click', (event) => {
		removeRow(event.target.parentElement.parentElement.id);
	});
	imgTag.style.cursor = "pointer";
	tdTag.appendChild(imgTag);
}

function removeRow(id) {
	//filterFlag = true;
	var trTag = document.getElementById(id);
	var labelName = trTag.cells[0].innerHTML;

	if (labelName.includes("<")) {

		var selectTag = trTag.querySelector("td > select");
		labelName = selectTag.options[selectTag.selectedIndex].text;
		// console.log(selectTag);
		if (selectTag.selectedIndex == 0 && !window.filterFlag) {
			window.filterFlag = true;
		}
	}

	for (var i = 0; i < window.globalTableHeads_v2.length; i++) {

		if (window.globalTableHeads_v2[i].labelName == labelName) {
			window.globalTableHeads_v2[i].filterFlag = false;

			// if(window.globalTableHeads_v2[i].fieldType == "date"){
			window.globalTableHeads_v2[i].filterValue = "";
			window.globalTableHeads_v2[i].secondValue = "";
			window.globalTableHeads_v2[i].comparisonType = '=';
			// }
			// remainingColumns.push(window.globalTableHeads_v2[i]);

			if (!window.filterFlag) {

				var selectTag = document.getElementById("s-f-t#" + window.GlobalId_v2 + (filterRowId - 1));
				var optionTag = document.createElement("option");
				var value = document.createTextNode(labelName);
				optionTag.appendChild(value);
				selectTag.appendChild(optionTag);
				// console.log(selectTag);
			}
			break;
		}
	}

	trTag.parentNode.removeChild(trTag);

	// removing Value 2 label
	let allOperatorSelects = document.getElementsByClassName("sdt-f-select");
	let count = 0;
	for (var i = 0; i < allOperatorSelects.length; i++) {
		if (allOperatorSelects[i].id.includes('s2')) {
			let options = allOperatorSelects[i].options;
			let selectedIndex = allOperatorSelects[i].options.selectedIndex;
			for (let index = 0; index < options.length; index++) {
				if (index == selectedIndex) {
					if (options[index].label == "Between") {
						count++;
					}
				}
			}
		}
	}

	if (count == 0) { //then remove label
		let rows = document.getElementsByTagName('th');
		for (let i = 0; i < rows.length; i++) {
			if (rows[i].id.includes('secondValue')) {
				rows[i].innerText = '';
			}
			if (rows[i].id.includes('firstValue')) {
				rows[i].innerText = "Value";
			}
		}
		checkFlag = false;
	}

}

window.borderBottomCSS = "1px solid #dadada";

function setupHeader(filterDiv) {

	//Header Section
	var divHeading = document.createElement('div');
	divHeading.style.fontWeight = "bold";
	divHeading.style.padding = "10px";
	divHeading.style['border'] = window.borderBottomCSS;

	var spanHeading = document.createElement('span');
	spanHeading.style.width = "60%";
	spanHeading.style.display = "inline-block";

	var label = document.createTextNode("Column Filters");
	spanHeading.appendChild(label);
	divHeading.appendChild(spanHeading);

	// adding clear filter functionality
	var spanClearFilter = document.createElement('span');
	spanClearFilter.style.width = "20%";
	spanClearFilter.style.display = "inline-flex";
	var label2 = document.createTextNode("Clear Filters");
	spanClearFilter.style.color = window.globalBlackColor;
	spanClearFilter.setAttribute('onmouseover', "this.style.textDecoration='none';");
	spanClearFilter.setAttribute('onmouseout', "this.style.textDecoration='underline';");
	spanClearFilter.style.cursor = "pointer";
	spanClearFilter.style['position'] = 'relative';
	spanClearFilter.style['left'] = '35px';
	spanClearFilter.appendChild(label2);

	spanClearFilter.addEventListener('click', (event) => {
		clearFilter();
	})

	var spanAddFilter = document.createElement('span');
	spanAddFilter.style.width = "20%";
	spanAddFilter.style.display = "inline-block";
	var label = document.createTextNode(" Add Filter");
	var anchorTag = document.createElement('a');
	anchorTag.style.color = window.globalBlackColor;
	//anchorTag.style['text-decoration']= "none";
	anchorTag.setAttribute('onmouseover', "this.style.textDecoration='none';");
	anchorTag.setAttribute('onmouseout', "this.style.textDecoration='underline';");
	anchorTag.id = "sh-a-t#" + window.GlobalId_v2;

	var imgTag = document.createElement('img');
	// imgTag.src=require("@/shared/assets/icons/v2/add-btn2.png");
	imgTag.style.cursor = "pointer";
	imgTag.style['padding-top'] = "6px";
	anchorTag.appendChild(imgTag);

	anchorTag.appendChild(label);
	anchorTag.href = "javascript:void(0);";
	//too attach an on click event;
	anchorTag.addEventListener('click', (event) => {
		// console.log("The test.");
		addRow();
	});

	spanAddFilter.appendChild(anchorTag);
	spanAddFilter.style['text-align'] = 'right';
	divHeading.appendChild(spanClearFilter);
	divHeading.appendChild(spanAddFilter);

	filterDiv.appendChild(divHeading);
}

function clearFilter() {
	// removing all filters from columns
	for (let index = 0; index < window.globalTableHeads_v2.length; index++) {
		window.globalTableHeads_v2[index].comparisonType = '=';
		window.globalTableHeads_v2[index].filterValue = '';
		window.globalTableHeads_v2[index].secondValue = '';
		window.globalTableHeads_v2[index].compTypeDate = '';
		window.globalTableHeads_v2[index].thirdValue = '';
	}

	var allRows = document.getElementsByTagName('tr');
	for (let i = 0; i < allRows.length; i++) {
		while (allRows[i].id.includes('f-t#') && !allRows[i].id.includes('0')) {
			removeRow(allRows[i].id);
		}
	}

	// removing value 2 label
	let rows = document.getElementsByTagName('th');
	for (let i = 0; i < rows.length; i++) {
		if (rows[i].id.includes('secondValue')) {
			rows[i].innerText = '';
		}
		if (rows[i].id.includes('firstValue')) {
			rows[i].innerText = "Value";
		}
	}
	checkFlag = false;

	// removing count from tile
	let count = document.getElementById("tileCount-" + window.globalCurrentView_v2);
	if (count != null) {
		count.innerText = "";
	}
	addRow();

	// to reset table content
	var event = new CustomEvent("searchEvent");
	window.dispatchEvent(event);
}

window.filterFlag = true;

function addRow() {

	emptyNotification();
	if (window.filterFlag) {

		window.filterFlag = false;
		var tableTag = document.getElementById("f-t#" + window.GlobalId_v2);
		var trTag = document.createElement('tr');
		trTag.id = tableTag.id + filterRowId.toString();
		filterRowId++;
		var tdTag = document.createElement('td');
		tdTag.style['border-bottom'] = window.borderBottomCSS;
		var inputSelect = document.createElement('select');
		inputSelect.className = "sdt-f-select";
		inputSelect.id = "s-" + trTag.id;
		var optionTag = document.createElement("option");
		var value = document.createTextNode("");
		optionTag.appendChild(value);
		inputSelect.appendChild(optionTag);

		remainingColumns = removeDuplicateFilters(remainingColumns, 'labelName', 'filters');
		for (var i = 0; i < remainingColumns.length; i++) {
			//var opt = ;
			var optionTag = document.createElement("option");
			var value = document.createTextNode(remainingColumns[i].labelName);
			optionTag.appendChild(value);
			inputSelect.appendChild(optionTag);
		}

		tdTag.appendChild(inputSelect);
		trTag.appendChild(tdTag);

		var inputSelect2 = document.createElement('select');
		inputSelect2.className = "sdt-f-select";
		inputSelect2.id = "s2-" + inputSelect.id;
		tdTag = document.createElement('td');
		tdTag.style['border-bottom'] = window.borderBottomCSS;
		tdTag.appendChild(inputSelect2);
		trTag.appendChild(tdTag);

		tdTag = document.createElement('td');
		var inputValue = document.createElement('input');
		inputValue.type = "text";
		inputValue.className = "sdt-f-input";
		tdTag.appendChild(inputValue);
		tdTag.style['border-bottom'] = window.borderBottomCSS;
		trTag.appendChild(tdTag);

		tdTag = document.createElement('td');
		trTag.appendChild(tdTag);

		tdTag = document.createElement('td');
		tdTag.style = "width: 11px;display: -webkit-inline-box;padding-top: 10px;";
		generateDeleteButton(tdTag)
		trTag.appendChild(tdTag);

		tableTag.appendChild(trTag);

		inputSelect.onchange = function (event) {

			var labelName = event.target.value;

			if (labelName != "") {

				var selectedRow = null;
				let fieldType;
				for (var j = 0; j < window.globalTableHeads_v2.length; j++) {
					if (window.globalTableHeads_v2[j].labelName == labelName) {
						fieldType = window.globalTableHeads_v2[j].fieldType;
						let comparisonType = window.globalTableHeads_v2[j].comparisonType;
						selectedRow = window.globalTableHeads_v2[j];
						break;
					}
				}

				var select2 = document.getElementById("s2-" + this.id);
				generateComparisonDropDown(select2, selectedRow.fieldType, selectedRow.comparisonType);
				var parentRow = select2.parentNode.parentNode;
				if (selectedRow.dataType == "array") {
					parentRow.cells[2].innerHTML = "";
					var valSelect = document.createElement('select');
					for (var i = 0; i < selectedRow.filterOptions.length; i++) {
						var valOption = document.createElement('option')
						var optionValue = document.createTextNode(selectedRow.filterOptions[i]);
						valOption.appendChild(optionValue);
						valSelect.className = "sdt-f-select";
						valSelect.appendChild(valOption);
					}
					parentRow.cells[2].appendChild(valSelect);
				}
				if (fieldType == "date") {
					let inputTag = parentRow.cells[2].querySelector('input');
					inputTag.placeholder = "dd.mm.yyyy";
				}

				window.filterFlag = true;
				// this.setAttribute("disabled","true");
				// for (var i=0;i<remainingColumns.length;i++) {
				// 	//var opt = ;
				// 	if (labelName==remainingColumns[i].labelName) {
				// 		remainingColumns.splice(i,1);
				// 		break;
				// 	}
				// }

				emptyNotification();
			}
		};
	}
	// else if (remainingColumns.length==0) {
	// 	displayNotification("No more field available.");
	// }
	else {
		displayNotification("Please add one filter at a time.");
	}
}

function displayNotification(text) {

	var notDiv = document.getElementById("f-n#" + window.GlobalId_v2);
	var label = document.createTextNode(text);
	notDiv.appendChild(label);
	notDiv.style.display = "block";
	notDiv.style.paddingRight = "5px";
}

function emptyNotification() {

	var notDiv = document.getElementById("f-n#" + window.GlobalId_v2);
	notDiv.innerHTML = "";
	notDiv.style.display = "none";
}

let checkFlag = false; //to check if Value 2 label already added before or not
function generateComparisonDropDown(inputSelect3, fieldType, selectedValue) {
	if (fieldType == "string") {

		var optionElement2 = document.createElement('option')
		var optionValue = document.createTextNode("Equal to");
		if (selectedValue == "=") {
			optionElement2.selected = true;
		}
		optionElement2.appendChild(optionValue);
		inputSelect3.appendChild(optionElement2);

		var optionElement3 = document.createElement('option')
		var optionValue = document.createTextNode("Not equal to");
		if (selectedValue == "!=") {
			optionElement3.selected = true;
		}
		optionElement3.appendChild(optionValue);
		//inputSelect3.selectedIndex = 1;
		inputSelect3.appendChild(optionElement3);

		var optionElement4 = document.createElement('option')
		var optionValue = document.createTextNode("Contains");
		if (selectedValue == "Like") {
			optionElement4.selected = true;
		}
		optionElement4.appendChild(optionValue);
		//inputSelect3.selectedIndex = 1;
		inputSelect3.appendChild(optionElement4);
	} else {
		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Greater than");
		optionElement.appendChild(optionValue);
		if (selectedValue == ">") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement3 = document.createElement('option')
		var optionValue = document.createTextNode("Less than");
		optionElement3.appendChild(optionValue);
		if (selectedValue == "<") {
			optionElement3.selected = true;
		}
		inputSelect3.appendChild(optionElement3);

		var optionElement7 = document.createElement('option')
		var optionValue = document.createTextNode("Greater than equal to");
		if (selectedValue == ">=") {
			optionElement7.selected = true;
		}
		optionElement7.appendChild(optionValue);
		//inputSelect3.selectedIndex = 1;
		inputSelect3.appendChild(optionElement7);

		var optionElement8 = document.createElement('option')
		var optionValue = document.createTextNode("Less than equal to");
		if (selectedValue == "<=") {
			optionElement8.selected = true;
		}
		optionElement8.appendChild(optionValue);
		//inputSelect3.selectedIndex = 1;
		inputSelect3.appendChild(optionElement8);

		var optionElement2 = document.createElement('option')
		var optionValue = document.createTextNode("Equal to");
		optionElement2.appendChild(optionValue);
		if (selectedValue == "=") {
			optionElement2.selected = true;
		}
		inputSelect3.appendChild(optionElement2);

		var optionElement5 = document.createElement('option')
		var optionValue = document.createTextNode("Not equal to");
		optionElement5.appendChild(optionValue);
		if (selectedValue == "!=") {
			optionElement5.selected = true;
		}
		inputSelect3.appendChild(optionElement5);

		var optionElement6 = document.createElement('option')
		var optionValue = document.createTextNode("Contains");
		if (selectedValue == "Like") {
			optionElement6.selected = true;
		}
		optionElement6.appendChild(optionValue);
		//inputSelect3.selectedIndex = 1;
		inputSelect3.appendChild(optionElement6);

		var optionElement4 = document.createElement('option')
		var optionValue = document.createTextNode("Between");
		optionElement4.appendChild(optionValue);
		if (selectedValue == "btw") {
			optionElement4.selected = true;
		}
		inputSelect3.appendChild(optionElement4);
	}
	// relative dates options
	if (fieldType == "date") {
		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Day(s) ago");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Day(s) ago") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Week(s) ago");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Week(s) ago") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Month(s) ago");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Month(s) ago") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Quarter(s) ago");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Quarter(s) ago") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Year(s) ago");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Year(s) ago") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Day(s) from now");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Day(s) from now") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Week(s) from now");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Week(s) from now") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Month(s) from now");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Month(s) from now") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Quarter(s) from now");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Quarter(s) from now") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

		var optionElement = document.createElement('option');
		var optionValue = document.createTextNode("Year(s) from now");
		optionElement.appendChild(optionValue);
		if (selectedValue == "Year(s) from now") {
			optionElement.selected = true;
		}
		inputSelect3.appendChild(optionElement);

	}

	inputSelect3.onchange = function (event) {

		var rowTag = event.target.parentElement.parentElement;
		var selectedValue = event.target.value;
		let rows = document.getElementsByTagName('th');

		// not showing dd.mm.yyyy placeholder for relative date options
		if (checkRelativeDateFilter(selectedValue)) {
			rowTag.cells[2].childNodes[0].placeholder = "";
			for (let i = 0; i < rows.length; i++) {
				if (rows[i].id.includes('secondValue')) {
					rows[i].innerText = "";
				}
			}
		}
		if (selectedValue == "Between") {
			// adding Value 2 label
			if (!checkFlag) {
				for (let i = 0; i < rows.length; i++) {
					if (rows[i].id.includes('secondValue')) {
						let label = document.createTextNode("Value 2");
						rows[i].appendChild(label);
						checkFlag = true;
					}

					if (rows[i].id.includes('firstValue')) {
						rows[i].innerText = "Value 1";
					}
				}
			}

			var inputValue = document.createElement('input');
			inputValue.type = "text";
			inputValue.style.border = 'none';
			inputValue.style = "border-bottom: 1px solid #dadada;border-top: none;border-right: none;border-left: none;width: -webkit-fill-available;padding: 10px;outline: none;";
			if (fieldType == "date") {
				rowTag.cells[2].childNodes[0].placeholder = "dd.mm.yyyy";
				inputValue.placeholder = "dd.mm.yyyy";
			} else {
				inputValue.placeholder = "";
			}

			rowTag.cells[3].appendChild(inputValue);
		} else if (fieldType == "date" && !checkRelativeDateFilter(selectedValue)) {
			rowTag.cells[2].childNodes[0].placeholder = "dd.mm.yyyy";
			for (let i = 0; i < rows.length; i++) {
				if (rows[i].id.includes('secondValue')) {
					rows[i].innerText = "";
				}
			}
			rowTag.cells[3].innerHTML = "";
		} else {
			rowTag.cells[3].innerHTML = "";
		}
	};
}

export const toggleFilter_v2 = function (pageID) {
	var viewSpan = document.getElementById('custom-filter#' + pageID);
	if (viewSpan.style.display == "none") {
		viewSpan.style.display = "table";
	} else {
		viewSpan.style.display = "none";
	}
}

function validatedate(inputText) {
	if (inputText) {
		var dateformat = /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/;
		if (inputText.match(dateformat)) {
			var opera2 = inputText.split('.');
			let lopera2 = opera2.length;
			if (lopera2 > 1) {
				var dd = parseInt(opera2[0]);
				var mm = parseInt(opera2[1]);
				var yy = parseInt(opera2[2]);
			}
			var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
			if (mm == 1 || mm > 2) {
				if (dd > ListofDays[(mm - 1)]) {
					displayNotification('Please enter correct date!');
					return false;
				}
			}
			if (mm == 2) {
				var lyear = false;
				if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
					lyear = true;
				}
				if ((lyear == false) && (dd >= 29)) {
					displayNotification('Please enter correct date!');
					return false;
				}
				if ((lyear == true) && (dd > 29)) {
					displayNotification('Please enter correct date!');
					return false;
				}
			} else {
				return true;
			}
		} else {
			displayNotification("Please enter date in dd.mm.yyyy format!")
			return false;
		}
	}
}

export const getGlobalFiltersArray_v2 = function () {
	return window.globalFiltersArray_v2;
}

export const resetGlobalFiltersArray_v2 = function () {
	if (window.globalTableHeads_v2.length > 0) {
		for (let field of window.globalTableHeads_v2) {
			if (field.filterFlag) {
				field.filterValue = "";
				field.filterFlag = false;
				if (field.filters.length > 0) {
					field.filters.length = 0;
				}
			}
		}
	}
	window.globalFiltersArray_v2.length = 0;
	return window.globalFiltersArray_v2;
}